module.exports = __webpack_public_path__ + "img/logoHor.4880d652.png";